import { useNavigate } from "react-router-dom";

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();
  const projectNavigate = (id) => navigate(`/project/${id}`);
  return (
    <div className="col">
      <div className="card h-100 bg-transparent box_shodow p-4 border-0">
        <img src={project.image} className="card-img-top" alt="..." />
        <div className="card-body d-flex flex-column">
          <h5 className="text-center">{project.title}</h5>
          <p className="card-text">{project.description}</p>
          <div className="text-center mt-auto">
            <a
              href={project.live}
              className="btn btn_shadow"
              target="_blank"
              rel="noreferrer"
            >
              Live Website
            </a>
            {/* <button
              onClick={() => projectNavigate(project.id)}
              className="btn btn_shadow"
              rel="noreferrer"
            >
              Project Details
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
